import type { UiSchema } from "@rjsf/utils";
import { FormHelperText } from "@mui/material";
import { getValueFromUiSchema } from "@/utils/schema";

export const HelpText = ({ uiSchema }: { uiSchema?: UiSchema }) => {
  const helperText = getValueFromUiSchema("help", uiSchema);
  return helperText ? <FormHelperText>{String(helperText)}</FormHelperText> : null;
};
